import React from 'react';
import { compose, withState, withHandlers, withProps } from 'recompose';
import { Expand } from 'components/core/Expand';
import { Button } from 'components/core/Button';
import { Text } from 'components/core/Text';
import Plus from 'components/svg/Plus';
import Minus from 'components/svg/Minus';
import PropTypes from 'prop-types';

import './UnitReservationFeeDropDown.scss';

const enhance = compose(
	withState('show', 'setShow', false),
	withHandlers({
		toggleShow:
			({ show, setShow }) => () => setShow(!show)
	}),
	withProps(({ fees, price }) => {
		let feeDetails = [
			{
				name: 'One-Time Admin Fee',
				price: fees?.admin?.value
			},
			{
				name: 'One-Time Lock Fee',
				price: fees?.lock?.value
			}
		];

		feeDetails = feeDetails.filter((fee) => fee.price > 0);

		const totalFee = fees?.totalFees?.value || 0;
		const priceTotal = price?.value || 0;

		const totalCost = (totalFee + priceTotal).toFixed(2);

		return {
			feeDetails,
			totalCost
		};
	})
);

function UnitReservationFeeDropDown({
	show,
	toggleShow,
	feeDetails,
	totalCost
}) {
	return (
		<div className="main-fees-container">
			<div>
				<Text color="gray" weight="ultraBold">
					The following fees shall apply:
				</Text>

				<ul>
					{feeDetails.map((fee) => (
						<li key={fee.name}>{`${fee.name}: $${fee.price}`}</li>
					))}
				</ul>
				<Text color="gray">
					Your first month's bill will be ${totalCost} plus taxes.
				</Text>
			</div>

			<div className="trigger-container">
				{show ? <Minus /> : <Plus />}

				<Button
					onClick={toggleShow}
					link
				>
					<Text color="gray">
						{show ?
							'Close Details About Admin Fees' :
							'Read More About Admin Fee'}
					</Text>
				</Button>
			</div>

			<Expand showing={show}>
				<div>
					<Text size="small" color="gray" weight="standard">
						The one-time, non-refundable admin fee is charged upon
						signing your lease agreement. This fee covers the costs
						associated with processing your application and setting
						up your account and access credentials, ensuring a
						smooth move-in process.
					</Text>
				</div>
			</Expand>
		</div>
	);
}

UnitReservationFeeDropDown.propTypes = {
	show: PropTypes.bool,
	toggleShow: PropTypes.func,
	feeDetails: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string,
			price: PropTypes.number
		})
	),
	totalCost: PropTypes.string
};

export default enhance(UnitReservationFeeDropDown);
